import { render, staticRenderFns } from "./siteParam.vue?vue&type=template&id=473f0da6&"
import script from "./siteParam.vue?vue&type=script&lang=js&"
export * from "./siteParam.vue?vue&type=script&lang=js&"
import style0 from "./siteParam.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports